import makeStyles from '@mui/styles/makeStyles';

import { signupTokens, teal900 } from '@/theme/colors';

export const useStyles = makeStyles({
  content: {
    padding: '32px 24px',
    textAlign: 'center',
  },
  icon: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    backgroundColor: signupTokens.successSurface,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: 'var(--onSurface)',
    margin: '0 0 8px 0',
  },
  subtitle: {
    fontSize: 14,
    color: 'var(--onSurfaceMuted)',
    margin: '0 0 24px 0',
  },
  bulletsBox: {
    backgroundColor: 'var(--surfaceElevated)',
    border: '1px solid var(--surfaceBorder)',
    borderRadius: 8,
    padding: 16,
    textAlign: 'left',
  },
  bulletsList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  bulletItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    marginBottom: 8,
    fontSize: 14,
    color: 'var(--onSurfaceMuted)',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  bulletCheckmark: {
    color: 'var(--brandPrimary)',
    flexShrink: 0,
    marginTop: 2,
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px 40px',
    borderTop: '1px solid var(--surfaceBorder)',
    backgroundColor: 'var(--surfaceElevated)',
  },
  dashboardButton: {
    width: '100%',
    backgroundColor: teal900,
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
    padding: '8px 24px !important',
    minHeight: '36px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: signupTokens.primaryHoverDark,
    },
  },
});
